// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.GwReport_reportPage__iYmDv {
  height: 100%;
  width: 100%;
  position: relative;
}

.GwReport_reportContent__Salqz {
  padding: 20px;
}
.GwReport_reportContent__Salqz h2 {
  margin-bottom: 24px;
  color: #1D283C;
}
.GwReport_reportContent__Salqz p {
  margin-bottom: 32px;
  color: #666;
  line-height: 1.6;
}

.GwReport_statsContainer__Odd49 {
  display: flex;
  gap: 20px;
  margin-top: 30px;
}

.GwReport_statCard__bA7C2 {
  background: white;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  flex: 1 1;
}
.GwReport_statCard__bA7C2 h3 {
  font-size: 16px;
  color: #666;
  margin-bottom: 12px;
}
.GwReport_statCard__bA7C2 .GwReport_statValue__PEgPg {
  font-size: 24px;
  font-weight: 600;
  color: #1D283C;
}`, "",{"version":3,"sources":["webpack://./src/pages/GwReport/GwReport.module.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,WAAA;EACA,kBAAA;AACF;;AAEA;EACE,aAAA;AACF;AACE;EACE,mBAAA;EACA,cAAA;AACJ;AAEE;EACE,mBAAA;EACA,WAAA;EACA,gBAAA;AAAJ;;AAIA;EACE,aAAA;EACA,SAAA;EACA,gBAAA;AADF;;AAIA;EACE,iBAAA;EACA,aAAA;EACA,kBAAA;EACA,wCAAA;EACA,SAAA;AADF;AAGE;EACE,eAAA;EACA,WAAA;EACA,mBAAA;AADJ;AAIE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AAFJ","sourcesContent":[".reportPage {\n  height: 100%;\n  width: 100%;\n  position: relative;\n}\n\n.reportContent {\n  padding: 20px;\n  \n  h2 {\n    margin-bottom: 24px;\n    color: #1D283C;\n  }\n  \n  p {\n    margin-bottom: 32px;\n    color: #666;\n    line-height: 1.6;\n  }\n}\n\n.statsContainer {\n  display: flex;\n  gap: 20px;\n  margin-top: 30px;\n}\n\n.statCard {\n  background: white;\n  padding: 20px;\n  border-radius: 8px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  flex: 1;\n  \n  h3 {\n    font-size: 16px;\n    color: #666;\n    margin-bottom: 12px;\n  }\n  \n  .statValue {\n    font-size: 24px;\n    font-weight: 600;\n    color: #1D283C;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"reportPage": `GwReport_reportPage__iYmDv`,
	"reportContent": `GwReport_reportContent__Salqz`,
	"statsContainer": `GwReport_statsContainer__Odd49`,
	"statCard": `GwReport_statCard__bA7C2`,
	"statValue": `GwReport_statValue__PEgPg`
};
export default ___CSS_LOADER_EXPORT___;
